/**
 * @generated SignedSource<<8c622af66baee6508772411917497ae2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ServiceAvailabilityResult = "ADDON_NOT_ACTIVE" | "AVAILABLE" | "FEATURE_NOT_INCLUDED_IN_PLAN" | "NO_CREDITS" | "SHOPIFY_DEV_STORE_NOT_ALLOWED" | "TRIAL_NOT_ALLOWED" | "USE_LIMIT_EXCEEDED";
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "VECTORIZE";
export type serviceAvailabilityStatusQuery$variables = {
  serviceWithCredits: ServicesWithCredits;
};
export type serviceAvailabilityStatusQuery$data = {
  readonly serviceAvailabilityStatus: ServiceAvailabilityResult;
};
export type serviceAvailabilityStatusQuery = {
  response: serviceAvailabilityStatusQuery$data;
  variables: serviceAvailabilityStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceWithCredits"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "serviceWithCredits",
        "variableName": "serviceWithCredits"
      }
    ],
    "kind": "ScalarField",
    "name": "serviceAvailabilityStatus",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceAvailabilityStatusQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "serviceAvailabilityStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bcb1b6255c528e7651a39fb8bc07cfc7",
    "id": null,
    "metadata": {},
    "name": "serviceAvailabilityStatusQuery",
    "operationKind": "query",
    "text": "query serviceAvailabilityStatusQuery(\n  $serviceWithCredits: ServicesWithCredits!\n) {\n  serviceAvailabilityStatus(serviceWithCredits: $serviceWithCredits)\n}\n"
  }
};
})();

(node as any).hash = "372dbc37015df78e94d07b6910709056";

export default node;
